import ModulePageHeading from '../../components/ModulePageHeading';
import { resolveApplicationNav } from '../../navigation/applicationNavigation';

function Application() {
  return (
    <div>
      <ModulePageHeading
        resolveNav={resolveApplicationNav}
        title="Application"
        infoTitle="Application"
        infoChildren={
          <p>
            Council-facing applications for BWOF and Compliance Schedule changes. Use the header sub-menu in the order
            below.
          </p>
        }
      />
      <div className="bg-card rounded-lg shadow border border-gray-200 p-6 max-w-3xl space-y-6">
        <section>
          <h2 className="text-lg font-semibold text-gray-900">Role of this menu</h2>
          <p className="mt-2 text-sm text-gray-600 leading-relaxed">
            Application manages paperwork submitted to (or prepared for) council: renewing a Building Warrant of Fitness,
            and amending a building&apos;s Compliance Schedule (CS). It is separate from day-to-day inspection jobs.
            Register engineers and partners under <strong>Registered Company</strong> first when an amendment needs
            expert or IQP involvement.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900">Suggested order</h2>
          <ol className="mt-3 space-y-3 text-sm text-gray-700 list-decimal list-inside leading-relaxed">
            <li>
              <strong>Apply BWOF</strong> — Prepare and track Building Warrant of Fitness applications for buildings
              that are due for renewal.
            </li>
            <li>
              <strong>Amend CS List</strong> — Compliance Schedule amendments (Form 11 / AC2109a and related paths):
              choose path and case type, link the building, select SS, run site inspection / expert steps, then complete
              the application pack.
            </li>
          </ol>
          <p className="mt-4 text-sm text-gray-500">
            Open each workflow from the header sub-menu (Overview · Apply BWOF · Amend CS List).
          </p>
        </section>
      </div>
    </div>
  );
}

export default Application;
